
import apiClient from './client';

export const ActivitiesNotAllowedAxiosInstance = apiClient;